import { render, staticRenderFns } from "./SimpleSupportedCell.vue?vue&type=template&id=6b2a6b5b&scoped=true&functional=true&"
import script from "./SimpleSupportedCell.vue?vue&type=script&lang=js&"
export * from "./SimpleSupportedCell.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSupportedCell.vue?vue&type=style&index=0&id=6b2a6b5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6b2a6b5b",
  null
  
)

export default component.exports